// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_803a77e","form":"_cdb9934","toggle":"_c8fb1f7","real":"_b11f2fb","play":"_0ab27a2","active":"_45ddec8"};